import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";

import PageLoading from "../PageLoading.jsx";

import * as API from "../../api/api.js";

const LocationDetails = () => {
  const [loading, setLoading] = useState();
  const [quaters, setQuaters] = useState(null);
  const { slug } = useParams();
  let navigate = useNavigate();

  const API_KEY = import.meta.env.VITE_GOOGLE_MAP_API;

  useEffect(() => {
    document.title = `Metro Traffic School - ${slug}`;
    setHeadQuatersDatas();
  }, []);

  const setHeadQuatersDatas = () => {
    setLoading(true);
    API.getDatas(`location/${slug}`)
      .then((res) => {
        setQuaters(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <>
      {!loading && quaters && (
        <section className="inner-page notranslate  d-flex align-items-center justify-content-center">
          <div className="overlay"></div>
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xl-12">
                <nav aria-label="breadcrumb">
                  <h4 className="main-heading text-capitalize text-center mb-0">
                    Locations
                  </h4>
                  <ol className="breadcrumb d-flex align-items-center justify-content-center">
                    <li className="breadcrumb-item">
                      <Link to="/" className="text-white">
                        Home
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="" className="text-white">
                        Locations
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link
                        onClick={() => navigate(-1)}
                        to={""}
                        className="text-white"
                      >
                        {slug.toLocaleLowerCase().includes("broward")
                          ? "Broward County"
                          : slug.toLocaleLowerCase().includes("palm")
                          ? "Palm Beach County"
                          : slug.toLocaleLowerCase().includes("central")
                          ? "Central Florida"
                          : "Miami Dade County"}
                      </Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      {quaters.title}
                    </li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
        </section>
      )}

      {quaters && (
        <section className="location-section section-padding">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 location-accordion mt-0">
                <div className="row">
                  <div className="col-12">
                    <h1 className="text-white">{quaters.title}</h1>
                    <div className="accordion-body col-12">
                      <div className="row">
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-4 mb-md-3 d-flex justify-content-between flex-column">
                          <div className="address">
                            <div className="address-detail mb-md-3">
                              {quaters.address.split(",")[0]}
                              <br />
                              {`${quaters.address.split(",")[1]}, ${
                                quaters.address.split(",")[2]
                              }`}{" "}
                              <br />
                              <a href="tel: 305-513-0063">
                                Phone: &nbsp;{quaters.phone}
                              </a>
                              <br />
                              Fax: &nbsp;{quaters.fax} <br />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 location-map mb-md-5 mb-3">
                <h1 className="text-white mb-md-4 mb-3">Directions</h1>
                <iframe
                  title={quaters.address}
                  src={`https://www.google.com/maps/embed/v1/place?q=${quaters.latitude},${quaters.longitude}&key=${API_KEY}`}
                  style={{ border: 0 }}
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 locations-info text-white">
                <div
                  dangerouslySetInnerHTML={{ __html: quaters.content }}
                ></div>
              </div>
            </div>
          </div>
        </section>
      )}
      {loading && (
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
            <PageLoading color={"var(--metro-yellow)"} classes={"justify-content-center"} />
          </div>
        </div>
      )}
    </>
  );
};

export default LocationDetails;
